import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { Link } from 'react-router-dom';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import havantride_logo from "../../../assets/havantride_logo.svg";
import { IconButton } from '@mui/material';
export default function TemporaryDrawer({ navItems }) {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: '80vw' }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {navItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <Link to={item.path} style={{ color: 'inherit', textDecoration: 'none' }}>
              <ListItemButton>
                <ListItemIcon>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}
      </List>

    </Box>
  );

  return (
    <div>
      <IconButton  onClick={toggleDrawer(true)} size='large'>
      <MenuRoundedIcon/>
      </IconButton>
      <Drawer open={open} onClose={toggleDrawer(false)}>
<Box sx={{px:4,py:1}}>
  
        <Link to="/">
          <img src={havantride_logo} width={150} alt="Havant Ride" />
        </Link>
        </Box>

        <Divider />
        {DrawerList}
        <Divider />
      </Drawer>
    </div>
  );
}
